import { ApprovalDialog } from "@/features/tools/components/buildin/approval-dialog";
import { QuestionDialog } from "@/features/tools/components/buildin/confirm-dialog";
import { PlanDialog } from "@/features/tools/components/buildin/plan-dialog";

export const Buildin = {
  ApprovalDialog,
  PlanDialog,
  QuestionDialog,
};
